import { CheckCircleIcon, XCircleIcon } from "@heroicons/react/24/outline";
import {
    EvergreenCommunityListingAvailability,
    ObservationFreshness,
    relativeTimeAgo,
} from "@sp-crm/core";
import { CommunityRequestAvailabilityUpdatePanel } from "components/communities/show-community/community-request-availability-update-panel";
import { defaultLinkStyle } from "components/ui/link";
import React, { useCallback } from "react";
import { ListableCommunity } from "../props";

interface LayoutItemAvailabilityExistingProps {
    community: ListableCommunity;
    canRequestAvailability: boolean;
}

export const LayoutItemAvailabilityExisting: React.FC<
    LayoutItemAvailabilityExistingProps
> = props => {
    const { community, canRequestAvailability } = props;

    const [isRequestUpdateDialogOpen, setIsRequestUpdateDialogOpen] =
        React.useState(false);

    const requestUpdate = useCallback(() => {
        setIsRequestUpdateDialogOpen(true);
    }, []);

    const closeRequestUpdateDialog = useCallback(() => {
        setIsRequestUpdateDialogOpen(false);
    }, []);

    const onRequestUpdateSuccess = useCallback(() => {
        closeRequestUpdateDialog();
    }, [closeRequestUpdateDialog]);

    return (
        <>
            {isRequestUpdateDialogOpen ? (
                <CommunityRequestAvailabilityUpdatePanel
                    communityId={community.id}
                    communityName={community.name}
                    availabilityStatus={community.availability.status}
                    onDismiss={closeRequestUpdateDialog}
                    onSuccess={onRequestUpdateSuccess}
                />
            ) : null}
            <dd className="mt-1 flex flex-col space-y-1">
                <div
                    className={`flex text-sm items-center space-x-1 ${
                        community.availability.status ===
                        EvergreenCommunityListingAvailability.Available
                            ? "text-green-600"
                            : "text-red-500"
                    }`}>
                    {community.availability.status ===
                    EvergreenCommunityListingAvailability.Available ? (
                        <>
                            <CheckCircleIcon className="w-4 h-4" />
                            <span>Yes</span>
                        </>
                    ) : (
                        <>
                            <XCircleIcon className="w-4 h-4" />
                            <span>No</span>
                        </>
                    )}
                </div>
                {community.availability?.lastUpdatedAt && (
                    <div className="text-xs text-gray-500">
                        Last updated{" "}
                        {relativeTimeAgo(community.availability.lastUpdatedAt)}
                    </div>
                )}
                {community.availability?.freshness === ObservationFreshness.Stale &&
                canRequestAvailability ? (
                    <a
                        href="#"
                        onClick={e => {
                            e.preventDefault();
                            requestUpdate();
                        }}
                        className={`${defaultLinkStyle} text-sm`}>
                        Request Update
                    </a>
                ) : null}
            </dd>
        </>
    );
};
